// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Calculator: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M18 22H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1ZM7 20h10V4H7v16Z" />
    <path d="M10.003 6h3.994C14.551 6 15 6.449 15 7.003v1.994C15 9.551 14.551 10 13.997 10h-3.994A1.003 1.003 0 0 1 9 8.997V7.003C9 6.449 9.449 6 10.003 6ZM9.499 12h1.002c.276 0 .499.223.499.499v1.002a.498.498 0 0 1-.499.499H9.499A.498.498 0 0 1 9 13.501v-1.002c0-.276.223-.499.499-.499ZM9.499 16h1.002c.276 0 .499.223.499.499v1.002a.498.498 0 0 1-.499.499H9.499A.498.498 0 0 1 9 17.501v-1.002c0-.276.223-.499.499-.499ZM13.499 12h1.002c.276 0 .499.223.499.499v1.002a.498.498 0 0 1-.499.499h-1.002a.498.498 0 0 1-.499-.499v-1.002c0-.276.223-.499.499-.499ZM13.499 16h1.002c.276 0 .499.223.499.499v1.002a.498.498 0 0 1-.499.499h-1.002a.498.498 0 0 1-.499-.499v-1.002c0-.276.223-.499.499-.499Z" />
  </SvgIcon>
);

Calculator.activeColor = 'inherit';
Calculator.muiName = 'Calculator';
